import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Trackings from '@/components/Trackings'
import TrackingDetail from '@/components/TrackingDetail'
import TrackingHistory from '@/components/TrackingHistory'
import TrackingEdit from '@/components/TrackingEdit'
import Drivers from '@/components/Drivers'
import DriverManage from '@/components/DriverManage'
import DriverTrackings from '@/components/DriverTrackings'
import Users from '@/components/Users'
import UserManage from '@/components/UserManage'
import ChangeRequests from '@/components/ChangeRequests'
import ChangeRequest from '@/components/ChangeRequest'
import ChangeRequestAdd from '@/components/ChangeRequestAdd'
import CsIssues from '@/components/CsIssues'
import CsIssueAdd from '@/components/CsIssueAdd'
import TrackingDetailOther from '@/components/TrackingDetailOther'
import ShopifyOrders from '@/components/ShopifyOrders'
import WMS_Products from '@/components/WMS_Products'
import WMS_Locations from '@/components/WMS_Locations'
import WMS_LocationsAdd from '@/components/WMS_LocationsAdd'
import WMS_Transactions from '@/components/WMS_Transactions'
import InboundShipments from '@/components/InboundShipments'
import InboundShipment from '@/components/InboundShipment'
import InboundShipmentCreate from '@/components/InboundShipmentCreate'
import InboundShipmentDN from '@/components/InboundShipmentDN'
import InventoryControl from '@/components/InventoryControl'
import InventoryControlNew from '@/components/InventoryControlNew'
import CommittedStockDiscrepancy from '@/components/CommittedStockDiscrepancy'
import OrderInventory from '@/components/OrderInventory'
import OrderInventoryDetail from '@/components/OrderInventoryDetail'
import WMS_Return_Order from '@/components/WMS_Return_Order'
import HKTOrders from '@/components/HKTOrders'
import CPROrders from '@/components/CPROrders'
import OrderMaster from '@/components/OrderMaster'
import OrderMasterDetail from '@/components/OrderMasterDetail'
import ProductMaster from '@/components/ProductMaster'
import VirtualKitMaster from '@/components/VirtualKitMaster'
import VirtualKitReverseMaster from '@/components/VirtualKitReverseMaster'
import Clients from '@/components/Clients'
import ChannelMaster from '@/components/ChannelMaster'
import FulfillmentProcess from '@/components/FulfillmentProcess'
import FulfillmentProcessV2 from '@/components/FulfillmentProcessV2'
import VendorOrder from '@/components/VendorOrder'
import DeliveryNote from '@/components/DeliveryNote'
import DeliveryNoteDetail from '@/components/DeliveryNoteDetail'
import CollectionNote from '@/components/CollectionNote'
import CollectionNoteDetail from '@/components/CollectionNoteDetail'
import StockinProcess from '@/components/StockinProcess'
import GolsSkuMaster from '@/components/GolsSkuMaster'
import RedemptionStatus from '@/components/RedemptionStatus'
import RedemptionLogs from '@/components/RedemptionLogs'
import ProductMasterEdit from '@/components/ProductMasterEdit'
import RedemptionLocationMaster from '@/components/RedemptionLocationMaster'
import CompanyMaster from '@/components/CompanyMaster'
import BackOrders from '@/components/BackOrders'
import BackOrderDetail from '@/components/BackOrderDetail'
import RouteAllocation from '@/components/RouteAllocation'
import ExternalRouteAllocation from '@/components/ExternalRouteAllocation'
import ExternalRouteAllocationV2 from '@/components/ExternalRouteAllocationV2'
import CommittedProducts from '@/components/CommittedProducts'
import OrderMasterEdit from '@/components/OrderMasterEdit'
import OrderMasterCreate from '@/components/OrderMasterCreate'
import RedemptionCenter from '@/components/RedemptionCenter'
import VendorProduct from '@/components/VendorProduct'
import CmsReport from '@/components/CmsReport'
import CmsPayment from '@/components/CmsPayment'
import AccountPasswordChange from '@/components/AccountPasswordChange'
import PickingStatus from '@/components/PickingStatus'
import CartonAmendment from '@/components/CartonAmendment'
import RescheduleDelivery from '@/components/RescheduleDelivery'
import PrintPdfPortal from '@/components/PrintPdfPortal'
import InternationalTracking from '@/components/InternationalTracking'
import RouteUpdate from '@/components/RouteUpdate'
import AutoRouteAssignment from '@/components/AutoRouteAssignment'
import PackingQueue from '@/components/PackingQueue'
import PackingQueueDetail from '@/components/PackingQueueDetail'
import CmsAccount from '@/components/CmsAccount'
import CmsAccountForm from '@/components/CmsAccountForm'
import CmsClient from '@/components/CmsClient'
import CmsClientSetup from '@/components/CmsClientSetup'
import HktvmallManualUpload from '@/components/HktvmallManualUpload'
import CmsPermissionGroup from '@/components/CmsPermissionGroup'
import CmsPermissionGroupForm from '@/components/CmsPermissionGroupForm'
import CmsTestBarcodeReader from '@/components/CmsTestBarcodeReader'
import CmsChangeLog from '@/components/CmsChangeLog'
import ProductMasterClone from '@/components/ProductMasterClone'
import InventoryCrossPlatformTransfer from '@/components/InventoryCrossPlatformTransfer'
import StockTakeJob from '@/components/StockTakeJob'
import StockTakeJobProduct from '@/components/StockTakeJobProduct'
import ReturnHandling from '@/components/ReturnHandling'
import TrackingLocationScan from '@/components/TrackingLocationScan'
import TrackingSMS from '@/components/TrackingSMS'
import ClientDashboard from '@/components/ClientDashboard'
import TrackingReturnProcess from '@/components/TrackingReturnProcess'
import TrackingReturnHandlings from '@/components/TrackingReturnHandlings'
import TrackingReturnHandlingAdd from '@/components/TrackingReturnHandlingAdd'
import AddressTemplate from '@/components/AddressTemplate'
import AddressTemplateAdd from '@/components/AddressTemplateAdd'
import AddressTemplateEdit from '@/components/AddressTemplateEdit'
import PackingProcess from '@/components/PackingProcess'
import DeliveryDashboard from '@/components/DeliveryDashboard'
import FulfillmentAnalytics from '@/components/FulfillmentAnalytics'
import UtilityFunctions from '@/components/UtilityFunctions'
import ProductLocationBulk from '@/components/ProductLocationBulk'
import PackingSectorProductPriority from '@/components/PackingSectorProductPriority'
import BotScheduleExceptions from '@/components/BotScheduleExceptions'
import SfShipmentQuotaDashboard from '@/components/SfShipmentQuotaDashboard'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/trackings',
      name: 'trackings',
      component: Trackings
    },
    {
      path: '/trackings/:id',
      name: 'tracking_detail',
      component: TrackingDetail
    },
    {
      path: '/tracking_history',
      name: 'tracking_history',
      component: TrackingHistory
    },
    {
      path: '/trackings_other/:id',
      name: 'tracking_detail_other',
      component: TrackingDetailOther
    },
    {
      path: '/trackings/:id/edit',
      name: 'tracking_edit',
      component: TrackingEdit
    },
    {
      path: '/drivers',
      name: 'drivers',
      component: Drivers
    },
    {
      path: '/drivers/:id/trackings',
      name: 'driver_trackings',
      component: DriverTrackings
    },
    {
      path: '/drivers/manage',
      name: 'driver_manage',
      component: DriverManage
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/users/manage',
      name: 'user_manage',
      component: UserManage
    },
    {
      path: '/change_requests',
      name: 'change_requests',
      component: ChangeRequests
    },
    {
      path: '/change_requests/:id/',
      name: 'change_request_detail',
      component: ChangeRequest
    },
    {
      path: '/change_request_add/',
      name: 'change_request_add',
      component: ChangeRequestAdd
    },
    {
      path: '/change_request_edit/:tracking_id/',
      name: 'change_request_edit',
      component: ChangeRequestAdd
    },
    {
      path: '/shopify_orders',
      name: 'shopify_orders',
      component: ShopifyOrders
    },
    {
      path: '/cs_issues',
      name: 'cs_issues',
      component: CsIssues
    },
    {
      path: '/cs_issue_add/',
      name: 'cs_issue_add',
      component: CsIssueAdd
    },
    {
      path: '/cs_issue_edit/:tracking_id',
      name: 'cs_issue_edit',
      component: CsIssueAdd
    },
    {
      path: '/wms_products',
      name: 'wms_products',
      component: WMS_Products
    },
    {
      path: '/wms_locations',
      name: 'wms_locations',
      component: WMS_Locations
    },
    {
      path: '/wms_locations_add',
      name: 'wms_locations_add',
      component: WMS_LocationsAdd
    },
    {
      path: '/wms_locations_edit/:wms_location_id',
      name: 'wms_locations_edit',
      component: WMS_LocationsAdd
    },
    {
      path: '/wms_transactions',
      name: 'wms_transactions',
      component: WMS_Transactions
    },

    {
      path: '/wms_return_orders',
      name: 'wms_return_orders',
      component: WMS_Return_Order
    },
    {
      path: '/inbound_shipments',
      name: 'inbound_shipments',
      component: InboundShipments
    },
    {
      path: '/inbound_shipments/:inbound_shipment_id',
      name: 'inbound_shipment',
      component: InboundShipment
    },
    {
      path: '/inbound_shipment_create',
      name: 'inbound_shipment_create',
      component: InboundShipmentCreate
    },
    {
      path: '/inbound_shipments/:inbound_shipment_id/:dn_id',
      name: 'inbound_shipment_dn',
      component: InboundShipmentDN
    },
    {
      path: '/inventory_control',
      name: 'inventory_control',
      component: InventoryControl
    },
    {
      path: '/inventory_control_new',
      name: 'inventory_control_new',
      component: InventoryControlNew
    },
    {
      path: '/committed_stock_discrepancy',
      name: 'committed_stock_discrepancy',
      component: CommittedStockDiscrepancy
    },
    {
      path: '/order_inventory',
      name: 'order_inventory',
      component: OrderInventory
    },
    {
      path: '/order_inventory_detail',
      name: 'order_inventory_detail',
      component: OrderInventoryDetail
    },
    {
      path: '/hkt_orders',
      name: 'hkt_orders',
      component: HKTOrders
    },
    {
      path: '/cpr_orders',
      name: 'cpr_orders',
      component: CPROrders
    },
    {
      path: '/channel_master',
      name: 'channel_master',
      component: ChannelMaster
    },
    {
      path: '/order_master',
      name: 'order_master',
      component: OrderMaster
    },
    {
      path: '/order_master_detail/:order_master_id',
      name: 'order_master_detail',
      component: OrderMasterDetail
    },
    {
      path: '/product_master',
      name: 'product_master',
      component: ProductMaster
    },
    {
      path: '/virtual_kit_master',
      name: 'virtual_kit_master',
      component: VirtualKitMaster
    },
    {
      path: '/virtual_kit_reverse_master',
      name: 'virtual_kit_reverse_master',
      component: VirtualKitReverseMaster
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/fulfillment_process',
      name: 'fulfillment_process',
      component: FulfillmentProcess
    },
    {
      path: '/fulfillment_process_v2',
      name: 'fulfillment_process_v2',
      component: FulfillmentProcessV2
    },
    {
      path: '/vendor_orders',
      name: 'vendor_orders',
      component: VendorOrder
    },
    {
      path: '/delivery_note',
      name: 'delivery_note',
      component: DeliveryNote
    },
    {
      path: '/delivery_note/:delivery_note_id',
      name: 'delivery_note_detail',
      component: DeliveryNoteDetail
    },
    {
      path: '/stockin_process',
      name: 'stockin_process',
      component: StockinProcess
    },
    {
      path: '/gols_sku_master',
      name: 'gols_sku_master',
      component: GolsSkuMaster
    },
    {
      path: '/redemption_status',
      name: 'redemption_status',
      component: RedemptionStatus
    },
    {
      path: '/redemption_logs/:tracking_number',
      name: 'redemption_logs',
      component: RedemptionLogs
    },

    {
      path: '/product_master/edit/:id',
      name: 'product_master_edit',
      component: ProductMasterEdit
    },
    {
      path: '/redemption_location_master',
      name: 'redemption_location_master',
      component: RedemptionLocationMaster
    },
    {
      path: '/company_master',
      name: 'company_master',
      component: CompanyMaster
    },
    {
      path: '/collection_note',
      name: 'collection_note',
      component: CollectionNote
    },
    {
      path: '/collection_note/:collection_note_id',
      name: 'collection_note_detail',
      component: CollectionNoteDetail
    },
    {
      path: '/back_orders',
      name: 'back_orders',
      component: BackOrders
    },
    {
      path: '/back_order_detail/:product_id/:bo_status',
      name: 'back_order_detail',
      component: BackOrderDetail
    },
    {
      path: '/route_allocation',
      name: 'route_allocation',
      component: RouteAllocation
    },
    {
      path: '/external_route_allocation',
      name: 'external_route_allocation',
      component: ExternalRouteAllocation
    },
    {
      path: '/external_route_allocation_v2',
      name: 'external_route_allocation_v2',
      component: ExternalRouteAllocationV2
    },
    {
      path: '/committed_products',
      name: 'committed_products',
      component: CommittedProducts
    },
    {
      path: '/order_master/add',
      name: 'order_master_add',
      component: OrderMasterCreate
    },
    {
      path: '/order_master/edit/:id',
      name: 'order_master_edit',
      component: OrderMasterEdit
    },
    {
      path: '/redemption_center',
      name: 'redemption_center',
      component: RedemptionCenter
    },
    {
      path: '/vendor_products',
      name: 'vendor_products',
      component: VendorProduct
    },
    {
      path: '/cms_report',
      name: 'cms_report',
      component: CmsReport
    },
    {
      path: '/cms_payment',
      name: 'cms_payment',
      component: CmsPayment
    },
    {
      path: '/account_password_change',
      name: 'account_password_change',
      component: AccountPasswordChange
    },
    {
      path: '/picking_status',
      name: 'picking_status',
      component: PickingStatus
    },
    {
      path: '/carton_amendment',
      name: 'carton_amendment',
      component: CartonAmendment
    },
    {
      path: '/reschedule_delivery',
      name: 'reschedule_delivery',
      component: RescheduleDelivery
    },
    {
      path: '/print_pdf_portal',
      name: 'print_pdf_portal',
      component: PrintPdfPortal
    },
    {
      path: '/international_tracking',
      name: 'international_tracking',
      component: InternationalTracking
    },
    {
      path: '/route_update',
      name: 'route_update',
      component: RouteUpdate
    },
    {
      path: '/auto_route_assignment',
      name: 'auto_route_assignment',
      component: AutoRouteAssignment
    },
    {
      path: '/packing_queue',
      name: 'packing_queue',
      component: PackingQueue
    },
    {
      path: '/packing_queue_detail',
      name: 'packing_queue_detail',
      component: PackingQueueDetail
    },
    {
      path: '/cms_account',
      name: 'cms_account',
      component: CmsAccount
    },
    {
      path: '/cms_account/add',
      name: 'cms_account_add',
      component: CmsAccountForm
    },
    {
      path: '/cms_account/:user_id/edit',
      name: 'cms_account_edit',
      component: CmsAccountForm
    },
    {
      path: '/cms_client',
      name: 'cms_client',
      component: CmsClient
    },
    {
      path: '/cms_client_setup',
      name: 'cms_client_setup',
      component: CmsClientSetup
    },
    {
      path: '/hktvmall_manual_upload',
      name: 'hktvmall_manual_upload',
      component: HktvmallManualUpload
    },
    {
      path: '/cms_permission_group',
      name: 'cms_permission_group',
      component: CmsPermissionGroup
    },
    {
      path: '/cms_permission_group/add',
      name: 'cms_permission_group_add',
      component: CmsPermissionGroupForm
    },
    {
      path: '/cms_permission_group/:permission_group_id/edit',
      name: 'cms_permission_group_edit',
      component: CmsPermissionGroupForm
    },
    {
      path: '/cms_barcode_reader',
      name: 'cms_barcode_reader',
      component: CmsTestBarcodeReader
    },
    {
      path: '/cms_change_log',
      name: 'cms_change_log',
      component: CmsChangeLog
    },
    {
      path: '/product_master/clone/:id',
      name: 'product_master_clone',
      component: ProductMasterClone
    },
    {
      path: '/inventory_crossplatform_transfer',
      name: 'inventory_crossplatform_transfer',
      component: InventoryCrossPlatformTransfer
    },
    {
      path: '/cms_account',
      name: 'cms_account',
      component: CmsAccount
    },
    {
      path: '/cms_account/add',
      name: 'cms_account_add',
      component: CmsAccountForm
    },
    {
      path: '/cms_account/:user_id/edit',
      name: 'cms_account_edit',
      component: CmsAccountForm
    },
    {
      path: '/cms_client',
      name: 'cms_client',
      component: CmsClient
    },
    {
      path: '/stock_take_job',
      name: 'stock_take_job',
      component: StockTakeJob
    },
    {
      path: '/stock_take_job/product/:product_sku',
      name: 'stock_take_job_product',
      component: StockTakeJobProduct
    },
    {
      path: '/return_handling',
      name: 'return_handling',
      component: ReturnHandling
    },
    {
      path: '/tracking_location_scan',
      name: 'tracking_location_scan',
      component: TrackingLocationScan
    },
    {
      path: '/tracking_sms',
      name: 'tracking_sms',
      component: TrackingSMS
    },
    {
      path: '/client_dashboard',
      name: 'client_dashboard',
      component: ClientDashboard
    },
    {
      path: '/tracking_return_process',
      name: 'tracking_return_process',
      component: TrackingReturnProcess
    },
    {
      path: '/tracking_return_handlings',
      name: 'tracking_return_handlings',
      component: TrackingReturnHandlings
    },
    {
      path: '/tracking_return_handling_add',
      name: 'tracking_return_handling_add',
      component: TrackingReturnHandlingAdd
    },
    {
      path: '/address_template',
      name: 'address_template',
      component: AddressTemplate
    },
    {
      path: '/address_template_add',
      name: 'address_template_add',
      component: AddressTemplateAdd
    },
    {
      path: '/address_template/:address_template_id/edit',
      name: 'address_template_edit',
      component: AddressTemplateEdit
    },
    {
      path: '/packing_process',
      name: 'packing_process',
      component: PackingProcess
    },
    {
      path: '/delivery_dashboard',
      name: 'delivery_dashboard',
      component: DeliveryDashboard
    },
    {
      path: '/fulfillment_analytics',
      name: 'fulfillment_analytics',
      component: FulfillmentAnalytics
    },
    {
      path: '/utilityFunctions',
      name: 'utilityFunctions',
      component: UtilityFunctions
    },
    {
      path: '/productLocationBulk',
      name: 'productLocationBulk',
      component: ProductLocationBulk
    },
    {
      path: '/packing_sector_product_priority',
      name: 'packing_sector_product_priority',
      component: PackingSectorProductPriority
    },
    {
      path: '/bot_schedule_exceptions',
      name: 'bot_schedule_exceptions',
      component: BotScheduleExceptions
    },
    {
      path: '/sf_shipment_quota_dashboard',
      name: 'sf_shipment_quota_dashboard',
      component: SfShipmentQuotaDashboard
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js